<template>
  <div class="item">
    <div class="head">
      <span style="padding-left: 37px">قیمت واحد</span>
      <span>مقدار</span>
      <span>قیمت کل</span>
    </div>

    <div v-if="!sellOrderBook.length && !buyOrderBook.length" class="noData">
      <p class="text-no-data">
        درحال حاضر اطلاعاتی برای نمایش وجود ندارد
      </p>
    </div>


    <div class="true-show" v-if="sellOrderBook !== null &&  buyOrderBook !== null ">

      <div class="buy">
        <div v-for="(item , index2) in sellOrderBook" :key="index2"
             :style="{backgroundImage:`linear-gradient(-90deg  , rgba(207, 102, 121, 0.2) ${item.executedPercent}%, transparent ${item.executedPercent}%)`}"
             class="prog">
          <div style="color: rgba(230, 70, 98)">{{ item.unitPrice.toLocaleString() }}</div>
          <div>{{ item.executedAmount.toLocaleString() }}</div>
          <div>{{ item.wholePrice.toLocaleString() }}</div>
        </div>
      </div>

      <div class="border">
        <p class="selected">{{$toLocal(selectedPrice,$decimal[tradeTo])}}</p>
        <div class="line">
          <img src="../../../assets/public/Line2.png" alt="">
        </div>
      </div>

      <div class="sell">
        <div v-for="(item , index) in buyOrderBook" :key="index[0]"
             :style="{backgroundImage:`linear-gradient(-90deg  , rgba(110, 174, 168, 0.2) ${item.executedPercent}%, transparent ${item.executedPercent}%)`}"
             class="prog">
          <div style="color: rgba(4, 178, 162, 1)">{{ item.unitPrice.toLocaleString() }}</div>
          <div>{{ item.executedAmount.toLocaleString() }}</div>
          <div>{{ item.wholePrice.toLocaleString() }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import '@/lib/socket'
import {tradeTo,tradeFrom} from '@/lib/reuseableFunction'
// const io = require('socket.io-client')
import io from 'socket.io-client'


export default {
  name: "deep-trade",
// props:['orderBook'],
  watch: {
    '$route.params.tradeFrom'() {
      // this.getTradeHeader();
      this.socket.off();

      const io = require("socket.io-client");
      const socket = io("https://socket.vistadev.xyz/socket", {
        path: "/vtp",
        transports: ["websocket"],
        extraHeaders: {
          Authorization: this.state.token,
        },
        upgrade: true,
        connected: true,
        reconnection: true,
        rejectUnauthorized: false,
        reconnectionDelayMax: 5000,
        randomizationFactor: 0.5,
        timeout: 20000,

      });

      socket.close();
      socket.connect();
      socket.on("connect", () => {
        this.socket.close();

        console.log("connected");
      });
      let marketType = this.tradeFrom + '_' + this.tradeTo;
      socket.emit('listener', {marketType: marketType});
      socket.on(marketType, (data) => {
        let parsedData = JSON.parse(data);
        // this.$store.commit('setOrderBook', parsedData)
        // console.log(parsedData)
   const res = parsedData
        this.buyOrderBook = res.buyOrderBook.sort((a , b) =>{return a.unitPrice > b.unitPrice} )
        this.sellOrderBook = res.sellOrderBook.sort((a , b) =>{return a.unitPrice > b.unitPrice} )
        this.state.shopInfo.maxBuy = res.buyOrderBook.length ? res.buyOrderBook[0].unitPrice : 0
        this.state.shopInfo.minSell = res.sellOrderBook.length ? res.sellOrderBook[0].unitPrice : 0
        let lastBuy = this.buyOrderBook.slice(-1)[0].unitPrice
        // console.log(lastBuy)
        let lastSell = this.sellOrderBook.slice(-1)[0].unitPrice

        lastBuy > lastSell ? this.selectedPrice = lastBuy : this.selectedPrice = lastSell

        if(lastBuy === this.selectedPrice){
          return document.querySelector('.selected').style.color = 'rgba(4, 178, 162, 1)';
        }
        else if(lastSell === this.selectedPrice){
          return document.querySelector('.selected').style.color = 'rgba(230, 70, 98, 1)';
        }
        else if(lastBuy === lastSell) {

          return document.querySelector('.selected').style.color = 'white';
        }


      })
    },
    '$route.params.tradeTo'() {
      // this.getTradeHeader();

      this.socket.close();
      const io = require("socket.io-client");
      const socket = io("https://socket.vistadev.xyz/socket", {
        path: "/vtp",
        transports: ["websocket"],
        extraHeaders: {
          Authorization: this.state.token,
        },
        upgrade: true,
        connected: true,
        reconnection: true,
        rejectUnauthorized: false,
        reconnectionDelayMax: 5000,
        randomizationFactor: 0.5,
        timeout: 20000,
      });
      socket.close();
      socket.connect();
      socket.on("connect", () => {
        console.log("connected");
      });
      let marketType = this.tradeFrom + '_' + this.tradeTo;
      socket.emit('listener', {marketType: marketType});
      socket.on(marketType, (data) => {
        let parsedData = JSON.parse(data);
        // console.log(parsedData)
const res = parsedData
        this.buyOrderBook = res.buyOrderBook.sort((a , b) =>{return a.unitPrice > b.unitPrice} )
        this.sellOrderBook = res.sellOrderBook.sort((a , b) =>{return a.unitPrice > b.unitPrice} )
        this.state.shopInfo.maxBuy = res.buyOrderBook.length ? res.buyOrderBook[0].unitPrice : 0
        this.state.shopInfo.minSell = res.sellOrderBook.length ? res.sellOrderBook[0].unitPrice : 0
        let lastBuy = this.buyOrderBook.slice(-1)[0].unitPrice
        // console.log(lastBuy)
        let lastSell = this.sellOrderBook.slice(-1)[0].unitPrice

        lastBuy > lastSell ? this.selectedPrice = lastBuy : this.selectedPrice = lastSell

        if(lastBuy === this.selectedPrice){
          return document.querySelector('.selected').style.color = 'rgba(4, 178, 162, 1)';
        }
        else if(lastSell === this.selectedPrice){
          return document.querySelector('.selected').style.color = 'rgba(230, 70, 98, 1)';
        }
        else if(lastBuy === lastSell) {

          return document.querySelector('.selected').style.color = 'white';
        }



      })
      socket.on('disconnect', (reason) => {
        console.log("disconnected");
      })
    }
  },
//------------------------------------Data
  computed: {
    tradeTo, tradeFrom,
  }
  , data() {
    return {
      selectedPrice:0,
orderBook:[],
      type: "",
socket:'',
      sellOrderBook: [

      ],

      buyOrderBook: [

      ]
    }
  },

  methods: {
//     async getMarketDepth(){
// const response = await this.$store.state.orders
//
//       console.log(response);
//       const [res, ] = await this.$http.get('/orders/order-book', {
//         params: {
//           marketType: this.$route.params.tradeFrom + '_' + this.$route.params.tradeTo
//         }
//       })
//       this.buyOrderBook = res.buyOrderBook.sort((a , b) =>{return a.unitPrice > b.unitPrice} )
//       this.sellOrderBook = res.sellOrderBook.sort((a , b) =>{return a.unitPrice > b.unitPrice} )
//       this.state.shopInfo.maxBuy = res.buyOrderBook.length ? res.buyOrderBook[0].unitPrice : 0
//       this.state.shopInfo.minSell = res.sellOrderBook.length ? res.sellOrderBook[0].unitPrice : 0
//       let lastBuy = this.buyOrderBook.slice(-1)[0].unitPrice
//       // console.log(lastBuy)
//       let lastSell = this.sellOrderBook.slice(-1)[0].unitPrice
//
//       lastBuy > lastSell ? this.selectedPrice = lastBuy : this.selectedPrice = lastSell
//
//       if(lastBuy === this.selectedPrice){
//        return document.querySelector('.selected').style.color = 'rgba(4, 178, 162, 1)';
//       }
//       else if(lastSell === this.selectedPrice){
//         return document.querySelector('.selected').style.color = 'rgba(230, 70, 98, 1)';
//       }
// else if(lastBuy === lastSell){
//
//   return document.querySelector('.selected').style.color = 'white';
//
//       }
//       this.loading=false;
//     }
  },
 async mounted() {

    const io = require("socket.io-client");
    const socket = io("https://socket.vistadev.xyz/socket", {
      path: "/vtp",
      transports: ["websocket"],
      extraHeaders: {
        Authorization: this.state.token,
      },
      upgrade: true,
      connected: true,
      reconnection: true,
      rejectUnauthorized: false,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.5,
      timeout: 20000,

    });
    this.socket = socket;
    await socket.connect();

   await socket.on("connect", () => {
      console.log("connected");
    });

    let marketType = this.tradeFrom + '_' + this.tradeTo;

   await socket.emit('listener', {marketType: marketType});
   await socket.on(marketType, (data) => {

      let parsedData = JSON.parse(data);
      this.orderBook =parsedData
      // this.$store.commit('setOrderBook', parsedData)
      // console.log(this.orderBook)
     let res =parsedData;

         this.buyOrderBook = res.buyOrderBook.sort((a , b) =>{return a.unitPrice > b.unitPrice} )
         this.sellOrderBook = res.sellOrderBook.sort((a , b) =>{return a.unitPrice > b.unitPrice} )
         this.state.shopInfo.maxBuy = res.buyOrderBook.length ? res.buyOrderBook[0].unitPrice : 0
         this.state.shopInfo.minSell = res.sellOrderBook.length ? res.sellOrderBook[0].unitPrice : 0
         let lastBuy = this.buyOrderBook.slice(-1)[0].unitPrice
         // console.log(lastBuy)
         let lastSell = this.sellOrderBook.slice(-1)[0].unitPrice

         lastBuy > lastSell ? this.selectedPrice = lastBuy : this.selectedPrice = lastSell

         if(lastBuy === this.selectedPrice){
           return document.querySelector('.selected').style.color = 'rgba(4, 178, 162, 1)';
         }
         else if(lastSell === this.selectedPrice){
           return document.querySelector('.selected').style.color = 'rgba(230, 70, 98, 1)';
         }
         else if(lastBuy === lastSell) {

           return document.querySelector('.selected').style.color = 'white';
         }










      console.log(parsedData)

    })
   // await this.getMarketDepth()
  },
  created() {
    this.options = {
      autosize: false,
      symbol: this.$route.params.tradeFrom != 'TETHER' ? 'BINANCE:' + this.$coinsUnit[this.$route.params.tradeFrom] + 'USDT' : 'BINANCEUS:USDTUSD',
      height: '292px',
      width: '100%',
      timezone: 'Asia/Tehran',
      style: '1',
      theme: 'dark',
      locale: 'fa_IR',
      enable_publishing: true,
      withdateranges: true,
      range: 'ytd',
      hide_side_toolbar: false,
      allow_symbol_change: true,
      enabled_features: [
        'header_fullscreen_button'
      ],
    }

  }
//   async created() {
// var marketType = this.$route.params.tradeTo+ '_' + this.$route.params.tradeFrom;
// var token = this.state.token
//     const socket = await io("http://185.142.158.100:5902/socket", {
//       path: "/vtp",
//       transports: ["websocket"],
//       upgrade: false,
//       connected: true,
//       reconnection: true,
//       orderBook:[],
//       rejectUnauthorized: false,
//       reconnectionDelayMax: 5000,
//       randomizationFactor: 0.5,
//       timeout: 20000,
//       auth: {
//         token: token
//       },
//     });
//     socket.on('connect', () => {
//       this.state.loading = false
//       console.log('socket is connected');
//
//     });
//     var marketType = this.$route.params.tradeFrom+ '_' + this.$route.params.tradeTo;
//     console.log(marketType);
//    socket.on(marketType.toString(), (data)=>{
//      console.log('hi')
//      let parsedDate = JSON.parse(data)
// this.orderBook = parsedDate
//      console.log(this.orderBook);
//
//    });
//
//
//   }
}
</script>

<style lang="scss" scoped>
.item {
  width: 100%;
  direction: rtl;
  max-height: 745px;

  .head {
    margin-bottom: 10px;
  }
}

.head {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  text-align: center;

  span {
    color: #D7C8C8;
    font-size: small;
  }
}

.buy{
  // height: 330px;/
  overflow: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.sell{
  //height: 330px;
  max-height: 330px;
  overflow: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.true-show{
  display: flex;
  flex-direction: column;
  max-height: 745px;
  overflow: hidden;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.prog {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 0;
  color: rgba(72, 77, 86, 1);
  font-size: clamp(10px, 2.5vw, 12px);
  height: 24px;
  color: #D7C8C8;
  align-items: center;

  div {
    background-color: transparent;
    flex-grow: 1;
    display: flex;
    justify-content: space-around;
  }
}

.totla {
  text-align: center;
  //color: rgb(74, 163, 113);
  font-weight: 600;
}

.noData {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.text-no-data {
  color: #D7C8C8;
  font-size: clamp(12px, 2vw, 16px);
  font-weight: bold;
}

.border {
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;

  .line {
    width: 80%;

    img{
      width: 65%;
    }
  }

  .totla {
    color: rgba(4, 178, 162, 1);
    width: 20%;
  }
}
</style>